import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { TrophyIcon, ChevronDownIcon } from 'lucide-react';
import { modules } from '../data/content';
import { Eyebrow, SectionLead, SectionTitle } from './ui/Section';
const collapseTransition = {
  duration: 0.22,
  ease: [0.23, 1, 0.32, 1] as const
};
export function Modules() {
  const [open, setOpen] = useState(0);
  return <section className="mx-auto max-w-4xl px-4 py-12 md:py-14" data-id="element-199" data-mp="146ee1d2s77ka">
      <Eyebrow data-id="element-200" data-mp="1488yyre1yzod">
        <span className="inline-flex items-center gap-2" data-id="element-201" data-mp="1877y1vd3s27w">
          <TrophyIcon className="h-4 w-4" data-id="element-202" data-mp="187ripju514pm" /> Qué incluye el sistema
        </span>
      </Eyebrow>
      <SectionTitle data-id="element-203" data-mp="1d4zt2y91o4gb">
        6 tomos. De cero a 21K. <span className="text-accent" data-id="element-204" data-mp="1i5e1wiigzife">Todo organizado.</span>
      </SectionTitle>
      <SectionLead data-id="element-205" data-mp="1i3b2j7vfgcy0">
        No recibís información suelta sobre running. Recibís planificaciones para saber qué hacer
        según tu nivel y objetivo.
      </SectionLead>

      <div className="mt-8 space-y-3" data-id="element-206" data-mp="2tiznxut193wp">
        {modules.map((mod, index) => <div key={mod.name} className={`overflow-hidden rounded-2xl border bg-white transition-colors duration-150 ease-out ${open === index ? 'border-accent shadow-lg shadow-slate-200' : mod.featured ? 'border-primary/40' : 'border-line'}`} data-id="element-207" data-mp="1trvvrbmz0fr" data-mpi={index}>
            <button className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6" aria-expanded={open === index} onClick={() => setOpen(open === index ? -1 : index)} data-id="element-208" data-mp="3f1uw34ghofqn">
              <span className="flex items-start gap-3" data-id="element-209" data-mp="3676srjuh584h">
                <span className="text-2xl leading-none" data-id="element-210" data-mp="31b9b9a7h5vq4">{mod.icon}</span>
                <span data-id="element-211" data-mp="2watyajr3uq8o">
                  {mod.featured && <span className="mb-1 inline-flex rounded bg-primary px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-white" data-id="element-212" data-mp="2wabxraxetpuy">
                      Para profesores
                    </span>}
                  <b className="block text-sm font-black uppercase text-ink md:text-base" data-id="element-213" data-mp="2mn7x7jibvl1a">
                    {mod.name}
                  </b>
                  <small className="block text-xs font-bold leading-snug text-accent-dark md:text-sm" data-id="element-214" data-mp="28p1fpdxorxns">
                    {mod.period}
                  </small>
                </span>
              </span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 text-accent transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} data-id="element-215" data-mp="30ffr93i88xwa" />
            </button>
            <AnimatePresence initial={false} data-id="element-216" data-mp="2rmc4g4loz8oz">
              {open === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={collapseTransition} data-id="element-217" data-mp="2vmuy8475aott">
                  <ul className="grid gap-2 border-t border-line px-5 py-4 text-sm font-semibold text-slate-600 sm:grid-cols-2 md:px-6" data-id="element-218" data-mp="1cp86tmqkh4wn">
                    {mod.content.map(line => <li key={line} className="flex gap-2" data-id="element-219" data-mp="1mfb5o3kddd2w">
                        <span className="text-accent" data-id="element-220" data-mp="1mejbmx6f7neq">→</span>
                        {line}
                      </li>)}
                  </ul>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
}